import { useQueries } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getPaymentRequestEvidenceFile } from '@src/api'
import { DefaultApiGetPaymentRequestEvidenceFileRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchPaymentRequestEvidenceFiles = (
  params: DefaultApiGetPaymentRequestEvidenceFileRequest[],
  onSuccess?: (data: AxiosResponse<File>, index: number) => void
) => {
  const { axiosInstance } = useAxios()
  axiosInstance.defaults.responseType = 'arraybuffer'

  return useQueries({
    queries: params.map((param, index) => {
      return {
        enabled:
          !!param.organizationId &&
          !!param.paymentRequestId &&
          !!param.evidenceId,
        queryFn: () => getPaymentRequestEvidenceFile(axiosInstance, param),
        queryKey: [
          REACT_QUERY_CACHE_KEYS.GET_PAYMENT_REQUEST_EVIDENCE_FILE,
          param.paymentRequestId,
          param.evidenceId,
        ],
        onSuccess: (data: AxiosResponse<File>) =>
          onSuccess && onSuccess(data, index),
      }
    }),
    combine: (results) => {
      return {
        data: results.map((result) => result.data),
        isSuccess: results.every((result) => result.isSuccess),
      }
    },
  })
}
